import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { IErrorModel, IPaginatedResponse } from '@core/models/generic.model';
import auditService from 'services/api/audit.service';

// -------------------------------------------------------------------------

interface IAuditSliceState {
    loading: boolean;
    error: IErrorModel | undefined;
    audit: []
}

const initialState: IAuditSliceState = {
    loading: false,
    error: {} as IErrorModel,
    audit: [],
};

// -------------------------------------------------------------------------

export const getAuditThunk = createAsyncThunk<
    IPaginatedResponse,
    { size: number; page: number; username: string; actionType: string; entityType: string; status: string; ipAddress: string; entityId: string; startDate: string; endDate: string },
    { rejectValue: IErrorModel }
>(`/audit/getAudit`, async (params, { rejectWithValue }: any) => {
    try {
        const response: any = await auditService.getAudit(params);
        return response.data.auditLogs;
    } catch (err: any) {
        toast.error(err.errorMessage || 'Failed to fetch audit data', { autoClose: 5000 });
        return rejectWithValue(err);
    }
});

// -------------------------------------------------------------------------

export const exportAuditThunk = createAsyncThunk<
    any,
    { startDate: string, endDate: string, username: string, actionType: string },
    { rejectValue: IErrorModel }
>(`/audit/exportAudit`, async ({ startDate, endDate, username, actionType }, { rejectWithValue }: any) => {
    try {
        const response: any = await auditService.exportAudit(startDate, endDate, username, actionType);
        return response.data;
    } catch (err: any) {
        const error = err;
        return rejectWithValue(error);
    }
});

// -------------------------------------------------------------------------


const auditSlice = createSlice({
    name: `audit`,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // Get Audit
        builder.addCase(getAuditThunk.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getAuditThunk.fulfilled, (state: any, action: any) => {
            state.loading = false;
            state.audit = action.payload;
        });
        builder.addCase(getAuditThunk.rejected, (state, action) => {
            state.loading = false;
            state.audit = [];
            state.error = action.payload;
        });
    }
});

// -------------------------------------------------------------------------

export default auditSlice;
export const auditReducer = auditSlice.reducer;

